export function countsTowardQuestionNumber(state) {
  return !state?.noSubmit || state?.type === 'BoxError';
}
